import Emitter from "_actions/emitter";
import { gameConstants } from "_constants";

const initialState = {
  sports: null,
  games: null,
  allGames: [],
  loading: false,
  liveGames: [],
  liveGameProviders: [],
  /** API + reducer filtreleri sonrası bucket başına üretilen PROVIDERS ayar satırları */
  providerBucketAccessSettings: [],
};

export const unlistedGames = [
  43997,
  43066,
  101049,
  46143,
  14000,
  14002,
  14003,
  14004,
  43994,
  43996,
  43998,
  43999,
  118149,
  56276,
  "WCLIVE_0",

  25616,
  26723,
  30847,
  30857,
  25251,
  25661,
  25726,
  30970,
  25565,
  25492,
  30918,
  25538,
  25563,
  25606,
  25608,
  25726,
  25769,
  25756,
];

export const unlistedPermissions = [
  {
    provider: "bigpot",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "merkur",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "netent",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "aviatrix",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "sexygaming",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "spadegaming",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "n2",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "apollo",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "wmcasino",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "rich88",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "live22",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "ailivecasino",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "spribe",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "voltentertainment",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "mrslotty",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "goldenrace",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "wmg",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "kajot",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "microgaming",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "quickspin",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "worldentertainment",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "gaminator",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "jetx",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "btg",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "konami",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "portomaso",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "boominggames",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "fatpanda",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "epicwin",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "igt",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "dreamgaming",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "jili",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "toptrendgaming",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "spaceman",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "fachai",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "fachai",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
  {
    provider: "kagaming",
    middleware: "matgame",
    permissions: ["bigpot"],
  },
];

const BUCKET_SETTING_SUFFIX = {
  CASINO: "_CASINO_SLOTS_ACCESS",
  LIVE: "_LIVE_CASINO_ACCESS",
  GAMES: "_GAMES_ACCESS",
};

/**
 * `providerKeysByBucket` (filtrelenmiş oyun verisinden) için SettingName üretir.
 */
export function buildProviderBucketAccessSettings(providerKeysByBucket) {
  const order = ["CASINO", "LIVE", "GAMES"];
  const rows = [];
  for (const bucket of order) {
    const set = providerKeysByBucket[bucket];
    const suffix = BUCKET_SETTING_SUFFIX[bucket];
    if (!set || !suffix) continue;
    for (const k of [...set].sort()) {
      const base = String(k).replace(/\s+/g, "_").toUpperCase();
      rows.push({
        AllowToChilds: true,
        Type: "bool",
        SettingName: `${base}${suffix}`,
        DefaultValue: "true",
        Category: "PROVIDERS",
        SettingsID: 1,
        Value: true,
      });
    }
  }
  return rows;
}

export function buildAdminFunctions(providerKeysByBucket) {
  const order = ["CASINO", "LIVE", "GAMES"];
  const rowsByBucket = {
    CASINO: "",
    LIVE: "",
    GAMES: "",
  };
  for (const bucket of order) {
    const set = providerKeysByBucket[bucket];
    const suffix = BUCKET_SETTING_SUFFIX[bucket];
    if (!set || !suffix) continue;
    for (const k of [...set].sort()) {
      const base = String(k).replace(/\s+/g, "_").toUpperCase();

      rowsByBucket[bucket] += `{permissions.${base}${suffix} && (
        <Checkbox
          onChange={(value, checked, event) => {
            let _s = permissions;
            _s.${base}${suffix}.AllowToChilds = checked;
            _s.${base}${suffix}.Value = checked;
            SaveSettings(_s);
          }}
          defaultChecked={permissions.${base}${suffix}.Value}
        >
          {t("PROVIDER_SETTINGS", { key: "X_${k.replaceAll("GASEA_", "").replaceAll("_", " ")} ${bucket}" })}
        </Checkbox>
      )}`;
    }
  }
  return rowsByBucket;
}

export function game(state = initialState, action) {
  switch (action.type) {
    case gameConstants.UPDATE_SPORTS_DATA:
      return {
        ...state,
        sports: action.data,
        loading: false,
      };
    case gameConstants.UPDATE_GAMES_DATA:
      let _value = {};
      let _all = [];

      const sameNameGames = Object.fromEntries(
        Object.entries(
          action.data.reduce((a, v) => ((a[v.Name] ??= []).push(v), a), {}),
        )
          .filter(([_, arr]) => arr.length > 1)
          .map(([name, arr]) => [
            name,
            Object.values(
              arr.reduce((m, v) => {
                (m[v.middleware] ??= { ...v, CacheData: [] }).CacheData.push(
                  ...v.CacheData,
                );
                return m;
              }, {}),
            ).map((o) => ({
              ...o,
              CacheData: Object.values(
                o.CacheData.reduce((u, c) => ((u[c.id] ??= c), u), {}),
              ),
            })),
          ]),
      );

      for (let index = 0; index < action.data.length; index++) {
        if (
          unlistedPermissions.some(
            (x) =>
              x.provider == action.data[index].Name &&
              x.middleware == action.data[index].middleware,
          )
        ) {
          continue;
        } else {
          let _data = action.data[index].CacheData;
          _data = _data
            .filter((x) => !unlistedGames.includes(x.id))
            .map((x) => {
              x._midleware = action.data[index].middleware;
              if (action.data[index].middleware == "gasea") {
                let providerNameClean = action.data[index].Name.replaceAll(
                  " ",
                  "_",
                );
                providerNameClean = "GASEA_" + providerNameClean;
                x.vendor = providerNameClean;
              }
              if (action.data[index].middleware == "nonameHero") {
                let providerNameClean = action.data[index].Name.replaceAll(
                  " ",
                  "_",
                );
                providerNameClean = "NONAMEHERO_" + providerNameClean;
                x.vendor = providerNameClean;
              }
              x._currencies = action.data[index].RelProviders?.currencies || [];
              return x;
            });

          // Key oluşturma: sameNameGames içinde olanlar için name_middleware formatı
          const providerName = action.data[index].Name;
          const middleware = action.data[index].middleware;
          const isInSameNameGames = sameNameGames.hasOwnProperty(providerName);

          let key;
          if (isInSameNameGames) {
            // sameNameGames içinde: matgame için sadece Name, diğerleri için Name_middleware
            key =
              middleware === "matgame" || middleware === "nonameHero"
                ? providerName
                : `${providerName}_${middleware}`;
          } else {
            // sameNameGames içinde değil: sadece Name
            key = providerName;
          }

          if (action.data[index].middleware == "nonameHero") {
            let providerNameClean = key.replaceAll(" ", "_");
            providerNameClean = "NONAMEHERO_" + providerNameClean + "";
            _value[providerNameClean] = _data; //.filter(x => x._midleware == 'innova')
            _all.push(..._data);
          } else if (action.data[index].middleware == "gasea") {
            let providerNameClean = key.replaceAll(" ", "_");
            providerNameClean = "GASEA_" + providerNameClean + "";
            _value[providerNameClean] = _data; //.filter(x => x._midleware == 'innova')
            _all.push(..._data);
          } else {
            _value[key] = _data; //.filter(x => x._midleware == 'innova')
            _all.push(..._data);
          }
        }
      }

      debugger;
      return {
        ...state,
        games: _value,
        allGames: _all,
      };
    case gameConstants.UPDATE_LOADING:
      return {
        ...state,
        loading: action.data,
      };
    case gameConstants.UPDATE_LIVE_GAME:
      return {
        ...state,
        liveGames: action.data,
        loading: false,
      };
    case gameConstants.UPDATE_LIVE_GAME_PROVIDERS:
      return {
        ...state,
        liveGameProviders: action.data,
        loading: false,
      };
    default:
      return state;
  }
}

/*

      const codes = new Set();
      for (const arr of Object.values(_value)) {
        for (const game of arr) {
          if (game?.categoryCode != null) codes.add(game.categoryCode);
        }
      }
      [...codes].sort();

      const byCategory = {};
      for (const [valueKey, arr] of Object.entries(_value)) {
        const cats = new Set(
          arr.map(g => g?.categoryCode).filter(c => c != null && c !== '')
        );
        for (const c of cats) {
          const catKey = String(c).toUpperCase();
          (byCategory[catKey] ??= new Set()).add(valueKey);
        }
      }
      Object.fromEntries(
        Object.entries(byCategory).map(([c, s]) => [c, [...s].sort()])
      );

      const BUCKET_DEF = {
        CASINO: ['SLOTS'],
        LIVE: ['LIVE', 'LIVEGRAND'],
        GAMES: ['MINI', 'BINGO', 'FISH', 'INSTWIN', 'ARCADE'],
      };


      const upperKeys = Object.fromEntries(
        Object.entries(byCategory).map(([k, v]) => [String(k).toUpperCase(), v])
      );
      const byBucket = { CASINO: {}, LIVE: {}, GAMES: {} };
      for (const [bucket, codes] of Object.entries(BUCKET_DEF)) {
        for (const code of codes) {
          const row = upperKeys[code.toUpperCase()];
          if (row != null) byBucket[bucket][code] = row;
        }
      }
      const providerKeysByBucket = { CASINO: new Set(), LIVE: new Set(), GAMES: new Set() };
      for (const [bucket, codes] of Object.entries(BUCKET_DEF)) {
        for (const code of codes) {
          const list = byCategory[code.toUpperCase()];
          if (!list) continue;
          for (const k of list) providerKeysByBucket[bucket].add(k);
        }
      }

      const providerBucketAccessSettings =
        buildProviderBucketAccessSettings(providerKeysByBucket);

      const _jsonMongo = JSON.stringify(providerBucketAccessSettings);
      const _jsonAdminFuncsByBucket = buildAdminFunctions(providerKeysByBucket);
      const _casinoAdminFunctionsText = _jsonAdminFuncsByBucket.CASINO;
      const _liveAdminFunctionsText = _jsonAdminFuncsByBucket.LIVE;
      const _gamesAdminFunctionsText = _jsonAdminFuncsByBucket.GAMES;

*/
